var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_32_4326",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.51172C7.75212 4.51172 4.71387 7.54998 4.71387 11.2979V18.7626V19.4412V28.8323C4.71387 29.9704 6.03028 30.6031 6.91895 29.8922L10.7565 26.8221C11.2378 26.4371 11.8358 26.2273 12.4522 26.2273H25.0722C28.8201 26.2273 31.8584 23.1891 31.8584 19.4412V11.2978C31.8584 7.54997 28.8201 4.51172 25.0723 4.51172H11.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.51172C7.75212 4.51172 4.71387 7.54998 4.71387 11.2979V18.7626V19.4412V28.8323C4.71387 29.9704 6.03028 30.6031 6.91895 29.8922L10.7565 26.8221C11.2378 26.4371 11.8358 26.2273 12.4522 26.2273H25.0722C28.8201 26.2273 31.8584 23.1891 31.8584 19.4412V11.2978C31.8584 7.54997 28.8201 4.51172 25.0723 4.51172H11.5Z",
    fill: "url(#paint0_linear_32_4326)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91895 29.8922L7.13091 30.1571L6.91895 29.8922ZM5.05317 11.2979C5.05317 7.73737 7.93951 4.85103 11.5 4.85103V4.17241C7.56473 4.17241 4.37456 7.36259 4.37456 11.2979H5.05317ZM5.05317 18.7626V11.2979H4.37456V18.7626H5.05317ZM5.05317 19.4412V18.7626H4.37456V19.4412H5.05317ZM5.05317 28.8323V19.4412H4.37456V28.8323H5.05317ZM6.70698 29.6272C6.04049 30.1604 5.05317 29.6859 5.05317 28.8323H4.37456C4.37456 30.2549 6.02008 31.0458 7.13091 30.1571L6.70698 29.6272ZM10.5445 26.5572L6.70698 29.6272L7.13091 30.1571L10.9684 27.0871L10.5445 26.5572ZM25.0722 25.888H12.4522V26.5666H25.0722V25.888ZM31.5191 19.4412C31.5191 23.0017 28.6327 25.888 25.0722 25.888V26.5666C29.0075 26.5666 32.1977 23.3765 32.1977 19.4412H31.5191ZM31.5191 11.2978V19.4412H32.1977V11.2978H31.5191ZM25.0723 4.85103C28.6327 4.85103 31.5191 7.73736 31.5191 11.2978H32.1977C32.1977 7.36258 29.0075 4.17241 25.0723 4.17241V4.85103ZM11.5 4.85103H25.0723V4.17241H11.5V4.85103ZM10.9684 27.0871C11.3896 26.7502 11.9128 26.5666 12.4522 26.5666V25.888C11.7587 25.888 11.086 26.124 10.5445 26.5572L10.9684 27.0871Z",
    fill: "url(#paint1_linear_32_4326)",
    fillOpacity: 0.7,
    mask: "url(#path-1-inside-1_32_4326)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5676,
    cy: 15.4368,
    r: 1.69653,
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.3538,
    cy: 15.4368,
    r: 1.69653,
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.1399,
    cy: 15.4368,
    r: 1.69653,
    fill: "#2D3D95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_32_4326",
    x: 0.713867,
    y: 0.511719,
    width: 35.1445,
    height: 33.6802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32_4326"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_32_4326",
    result: "effect2_dropShadow_32_4326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32_4326",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_32_4326"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32_4326",
    x: 7.87109,
    y: 11.7402,
    width: 20.9648,
    height: 7.39307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_4326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_4326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_4326",
    x1: -4.1081,
    y1: -5.76044,
    x2: 43.6289,
    y2: 39.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_4326",
    x1: 5.39248,
    y1: 8.36378,
    x2: 28.02,
    y2: 28.8646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ad31971f2231c98d24048eefadc5f594.svg";
export { ForwardRef as ReactComponent };